export const gettingStartedSteps = Object.freeze([
    {
        number: "01",
        titleKey: "main.landing.gettingStarted.steps.registration.title",
        descriptionKey: "main.landing.gettingStarted.steps.registration.description",
    },
    {
        number: "02",
        titleKey: "main.landing.gettingStarted.steps.approval.title",
        descriptionKey: "main.landing.gettingStarted.steps.approval.description",
    },
    {
        number: "03",
        titleKey: "main.landing.gettingStarted.steps.work.title",
        descriptionKey: "main.landing.gettingStarted.steps.work.description",
    },
]);

export const gettingStartedSupport = Object.freeze({
    titleKey: "main.landing.gettingStarted.support.title",
    descriptionKey: "main.landing.gettingStarted.support.description",
    phone: {
        label: "8 (800) 222-70-79",
        href: "tel:88002227079",
    },
    email: {
        label: "support@svetofore.ru",
        href: "mailto:support@svetofore.ru",
    },
});

export const gettingStartedTrial = Object.freeze({
    badgeKey: "main.landing.gettingStarted.trial.badge",
    titleKey: "main.landing.gettingStarted.trial.title",
    descriptionKey: "main.landing.gettingStarted.trial.description",
    actionKey: "main.landing.gettingStarted.trial.action",
    href: "/register",
});
